// extracted by mini-css-extract-plugin
export var alertIcon = "_ok-0";